import { LoadingState } from "@/components/ui/loading-state";
import { lazy, Suspense } from "react";

const WorkflowReport = lazy(() => import("../WorkflowReport"));

export function BuilderReportStage() {
  return (
    <Suspense fallback={<LoadingState />}>
      <section className="builder-stage-frame flex min-h-0 flex-1 flex-col overflow-auto py-5" aria-label="FDD Report">
        <h2 className="mb-4 text-xl font-semibold">FDD Report</h2>
        <WorkflowReport />
      </section>
    </Suspense>
  );
}
